import { Injectable } from '@angular/core';
import { UnitFormatService } from '@converter';
import { ChartPropertyService, DataPointsService } from '@datapoints';
import { NumberFormattingOption } from '@localisation';


@Injectable()
export class AxisHelperService {
    constructor(
        private datapointService: DataPointsService,
        private chartProperties: ChartPropertyService,
        private unitFormatService: UnitFormatService
    ){}
    
    public numberFormatingOptions : NumberFormattingOption;

    public createAxisLabelFormater(axis, info, cache){
        if(cache[axis.valueField]){
            return cache[axis.valueField]
        }
       
        if(!info){
            return (input) => {
                return input.valueText
            };
        }
        cache[axis.valueField] = (input) => {
            const format = this.unitFormatService.format(
                input.value,
                info.descr,
                info.rep,
                true,
                null,
                this.numberFormatingOptions
            );
            if(format.value === ''){
                return input.valueText;
            }
            return format.value + ' ' + format.unit;
        }
    
        return cache[axis.valueField];
    }

    public getAxisName(plantId, datapointId, info) {
        const id = plantId + ';' + datapointId;
        return this.chartProperties.getAxisName(info, { id });
    }

    private async createAxis(plantId: string, datapointId: string, position: string, axes : any[], cache){
        const id = plantId + ';' + datapointId;
        const info = await this.datapointService.getDataPointInfo(id);
        const name = this.getAxisName(plantId, datapointId, info);
        const current = axes.find((axis) => axis.name === name);
        if(!current){
            const categories = this.chartProperties.getCategories(info);
            const axis: any = {
                name,
                categories: categories || null,
                position,
                type: "continuous",
                title: " ",
                valueField : id,
                visualRange : {}
            }
            axis.formater = this.createAxisLabelFormater(axis, info, cache);
            return axis;
        }
        return null;
    }

    public async createAxisFromDatapoints(datapoints: any[], cache){
        const axes = [];
        let position = 'right';
        for(const datapoint of datapoints) {
            position = position === 'right' ? 'left' : 'right';
            const axis = await this.createAxis(datapoint.plantId, datapoint.datapointId, position, axes, cache);
            if(axis) {
                axes.push(axis);
            }
        }
        return axes;

    }
}